module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="photo_wrapper">\n	';
 if (shouldShowProductBadges()) { ;
__p += '\n		<i class="product_badge ' +
((__t = ( getProductBadgeClasses() )) == null ? '' : __t) +
'" aria-hidden="true"></i>\n	';
 } else { ;
__p += '\n		<div id="photo_source" class="' +
((__t = ( getSource() )) == null ? '' : __t) +
'"></div>\n	';
 } ;
__p += '\n	';
 if (isVideo()) { ;
__p += '\n		<div id="video_holder">\n		';
 if (isYoutube()) { ;
__p += '\n			<div id="layer_video" class="youtube_video" style="background-image:url(' +
((__t = ( getBigUrl() )) == null ? '' : __t) +
');"></div>\n		';
 } else { ;
__p += '\n			<video id="layer_video" src="' +
((__t = ( getPhotoLink() )) == null ? '' : __t) +
'" loop muted></video>\n		';
 } ;
__p += '\n		</div>\n		<div id="play_button"></div>\n		<div id="mute_button" class="mute"></div>\n	';
 } else { ;
__p += '\n		<div id="photo_holder" style="background-image:url(' +
((__t = ( getPhotoLink() )) == null ? '' : __t) +
');"></div>\n	';
 } ;
__p += '\n	<div id="info_holder">\n		<a href="' +
((__t = (getSocialLink())) == null ? '' : __t) +
'" id="username" target="_blank">' +
((__t = ( getUsername() )) == null ? '' : __t) +
'</a>\n	</div>\n</div>\n';

}
return __p
}